// export const selectHttpMcBimItemsInStandardSpace = createSelector(
//   [selectHttpGetMcBimStandardSpace, selectProjectNo, (state: IRootState) => state],
//   (mcbimSpace, projectNo, state) => {
//     if (!mcbimSpace) return [];
//     const args = {
//       projectNo: projectNo,
//       spaceId: mcbimSpace._id as string,
//     };
//     return openapi.endpoints.getMcbimItemsInSpace.select(args)(state).data ?? [];
//   }
// );

import { createSelector } from "@reduxjs/toolkit";
import { IRootState } from "./app/store";
import { openapi } from "../openapi";
import { IProjectPublic } from "@backend/src/schemas";

export const selectProjectNo = (state: IRootState) => state.design.projectNo;

export const selectHttpCurrentProjct = createSelector(
  [selectProjectNo, (state: IRootState) => state],
  (projectNo, state) => {
    const args = {
      projectNo: Number(projectNo),
    };

    return openapi.endpoints.getMultiplacerProjectsSingleProject.select(args)(state)
      .data as IProjectPublic;
  }
);

export const selectCompCodePath = createSelector([selectHttpCurrentProjct], (project) => {
  return project?.compCodePath ?? null;
});
